const ProgressionPointConnector = ({ activeClass }) => (
  <div className={`repair-status-progress-connector ${activeClass}`} />
);

export default ProgressionPointConnector;
